import { useState, useRef, useEffect } from "react";
import {
  Drawer,
  Button,
  Typography,
  message,
  Flex,
  Form,
  Row,
  Col,
  Spin,
  Modal,
  Space,
} from "antd";
import {
  EditOutlined,
  PrinterOutlined,
  SaveOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { ReadyToPrint } from "../ReadyToPrint";
import { presessioninstruction } from "../../../services/presessioninstruction";
import { CitiesInput } from "../../input";
import { CitiesTextEditor } from "../../textEditor";
import OuthPrint from "../outh_print";
import { Activity } from "react";

const { Title, Text } = Typography;

const initialContent = `
<div style="text-align:left; margin-bottom: 10px;">
  
  <h3 style="font-size: 20px; color: #333; margin: 0;text-align:left">FUE Hair Transplant</h3>
</div>

<ul style="font-size: 16px; line-height: 2; padding-left: 5px; margin-bottom: 40px;">
  <li>One day before the procedure, do not take Nicotine, Caffeine and Alcohol i.e. (No Smoking, Alcohol, Tea, Coffee, Chocolates and Fizzy Drinks).</li>
  <li>10 Days before the procedure, do not take <strong>Aspirin</strong> and <strong>Disprin</strong> or their products. You can take Panadol, Paracetamol in case of headache or any other ache.</li>
  <li>24 hours before procedure, do not go for hard exercise including sex.</li>
  <li>5 days before, do not take any type of <strong>Multivitamin</strong> including Vitamin E.</li>
  <li>On procedure day, come with Breakfast.</li>
  <li>If you are using any medicine in routine, bring that along with you on procedure day.</li>
  <li>Wear button Down/Front open Shirt on procedure day.</li>
  <li>On procedure day, shampoo your head with "<strong>Organic hair scalp shampoo</strong>". After shampoo, do not apply any Gel or Oil on your scalp.</li>
  <li>If you are <strong>allergic to any medicine</strong>, please inform us in advance.</li>
  <li>Bring Blood tests i.e. <strong>PT, APTT, HIV, HEP.'B'</strong> and <strong>HEP.'C', Blood CP, BSR</strong> along with you on procedure day.</li>
</ul>

<div style="font-size: 16px; line-height: 1.8;">
  <p style="font-weight: bold; margin: 0 0 8px 0;">Cap CEFSPAN 400mg (daily one) x5 days</p>
  <p style="margin: 0; font-style: italic; color: #555;">(1 capsule after breakfast on the day of surgery)</p>
</div>
`;

const PreOperationInstructions = ({ visible, onClose, clientInfo }) => {
  const printRef = useRef();
  const [form] = Form.useForm();
  const [editedConsent, setEditedConsent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const clientDetails = clientInfo?.appointment?.client_info;
  useEffect(() => {
    if (visible && clientInfo) {
      form.setFieldsValue({
        name: clientDetails?.name,
        age: clientDetails?.age,
        city: clientDetails?.residence,
        fatherName: clientDetails?.fatherName,
        // consent: deltas?.consentFormDelta,
      });
      getAllInstructions();
    }
  }, [clientInfo, visible]);

  const getAllInstructions = async () => {
    setLoading(true);
    const preId = clientInfo?.preId;
    const res = await presessioninstruction.getPreSessionsSingle(preId);

    if (res) {
      const instruction = res?.instruction;
      form.setFieldsValue({ consent: instruction });
      setEditedConsent(instruction);
      setData(instruction);
    } else {
      message.error("Failed to load instructions");
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   setContent(editData?.name ?? initialContent);
  // }, [editData]);

  // const saveChanges = () => {
  //   setEditing(false);
  //   message.success("Instructions updated successfully!");
  // };

  // const cancelEditing = () => {
  //   setContent(serviceID ?? initialContent);
  //   // setEditing(false);
  // };

  // const quillModules = {
  //   toolbar: [
  //     [{ header: [1, 2, 3, false] }],
  //     ["bold", "italic"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     [{ align: [] }],
  //     ["clean"],
  //   ],
  // };

  // const quillFormats = ["header", "bold", "italic", "list", "bullet", "align"];

  return (
    <Drawer
      title="Pre-Operation Instructions aaa"
      width={800}
      onClose={onClose}
      open={visible}
      destroyOnClose
      footer={[
        <Flex gap={5}>
          <Button
            style={{ background: "#2F80ED" }}
            className="text-white border-0"
            icon={<PrinterOutlined />}
            onClick={() => {
              printRef.current?.(); // safely call print
            }}
          >
            Print
          </Button>
          <Button onClick={onClose}>Close</Button>
          {/* {editing ? (
            <>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={saveChanges}
              >
                Save
              </Button>
              <Button onClick={cancelEditing}>Cancel</Button>
            </>
          ) : (
            <Button icon={<EditOutlined />} onClick={startEditing}>
              Edit Instructions
            </Button>
          )} */}
        </Flex>,
      ]}
    >
      {/* Main Content Area */}
      <Form layout="vertical" form={form} requiredMark={false}>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <CitiesInput
              name="name"
              label="Name"
              required
              placeholder="Your Name"
              disabled
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="fatherName"
              label="Father Name"
              required
              placeholder="Father Name"
              disabled
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              disabled
              name="age"
              label="Age"
              required
              placeholder="Age"
            />
          </Col>
          <Col span={12}>
            <CitiesInput
              name="city"
              label="Address"
              required
              placeholder="City"
              disabled
            />
          </Col>
          <Col span={24}>
            {loading ? (
              <Flex justify="center" align="center" style={{ height: "200px" }}>
                <Spin
                  size="large"
                  indicator={
                    <SyncOutlined
                      spin
                      style={{ color: "var(--main-color)", fontSize: "24px" }}
                    />
                  }
                />
              </Flex>
            ) : (
              <CitiesTextEditor
                disabled
                name="consent"
                label="Instruction"
                required
                onChange={(val) => {
                  setEditedConsent(val);
                  form.setFieldsValue({ consent: val });
                }}
              />
            )}
          </Col>
        </Row>
      </Form>
      {/* Hidden Print Component - Matches exact design */}
      <div className="hidden">
        <ReadyToPrint
          print={printRef}
          name="Pre-Operation Instructions"
          Component={
            <div>
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  padding: "3px 8px",
                  marginBottom: 5,
                  background: "#f9f9f9",
                  marginBottom: 20,
                }}
              >
                <Row gutter={[8, 1]}>
                  <Col span={24}>
                    <Text style={{ fontSize: 10 }} strong>
                      MRN:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.mrn ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.name ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Father's Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.fatherName ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Age:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.age ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Address:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {clientDetails?.address ?? "N/A"}
                    </Text>
                  </Col>
                </Row>
              </div>
              <div
                ref={(el) => {
                  if (el) {
                    el.querySelectorAll(".ql-align-center").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "center",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-right").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "right",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-justify").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "justify",
                        "important",
                      );
                    });
                  }
                }}
                dangerouslySetInnerHTML={{
                  __html: editedConsent,
                }}
                style={{ marginTop: 10 }}
              ></div>
            </div>
          }
        />
      </div>
    </Drawer>
  );
};

export { PreOperationInstructions };
